import { useQuery } from "@tanstack/react-query";
import { useAuth } from "@/hooks/use-auth";

export function useCustomerEvidenceAccess(brandId: string | undefined) {
  const { user, isLoading: authLoading } = useAuth();
  const query = useQuery<{ enabled: boolean; canGenerate?: boolean }>({
    queryKey: ["/api/brands", brandId, "customer-evidence", "access", user?.id],
    enabled: !!brandId && user?.isMaster === true && !authLoading,
    queryFn: async ({ signal }) => {
      const response = await fetch(`/api/brands/${brandId}/customer-evidence/access`, {
        credentials: "include",
        signal,
      });
      if (response.status === 404 || response.status === 403) return { enabled: false };
      if (!response.ok) throw new Error("Could not check customer evidence access");
      return response.json();
    },
    retry: false,
    staleTime: 0,
    refetchOnMount: "always",
    refetchOnWindowFocus: "always",
    refetchInterval: 30_000,
  });
  const authorized = !!brandId && user?.isMaster === true && !authLoading;
  return {
    enabled: authorized && query.isFetchedAfterMount && !query.isError && query.data?.enabled === true,
    canGenerate: authorized && query.isFetchedAfterMount && !query.isError && query.data?.enabled === true && query.data?.canGenerate === true,
    loading: authLoading || (authorized && !query.isFetchedAfterMount),
  };
}
